import React, { useEffect, useState } from "react";
import {
	Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, Badge, Table
} from "reactstrap";
import Loader from "common/loader";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { post, get, put } from "../../helpers/api_helper";
import { DRIVERS_SEARCH, CLEAR_COLLECTOR_WALLET, PARTNERS_SEARCH, UPLOAD_FILE, COLLECTOR_SEARCH } from "helpers/api_endpoints";
import Select from "react-select";
import { Trans } from "react-i18next";

const ClearWallet = ({ type=1, id = "" }) => {
	const [change, setChange] = useState(0);
	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [walletBalance, setWalletBalance] = useState(null);
	const [bankNote, setBankNote] = useState(null);
    const [collectors, setCollectors] = useState([]);
    const [partners, setPartners] = useState([]);
    const [partnerBranches, setPartnerBranches] = useState([]);
    const [collectorId, setCollectorId] = useState(null);
    const [partnerId, setPartnerId] = useState(null);
    const [partnerBranchId, setPartnerBranchId] = useState(null);

	const [status, setStatus] = useState('');


    useEffect(() => {
        post(PARTNERS_SEARCH)
            .then(response => {
                const data = response.data;
                setPartners(data.map(el => 
                    ({value:el.id,label:el.name , data:el})));
            })
            .catch(() => setErrorMsg("Failed to load "));
        post(COLLECTOR_SEARCH)
            .then(response => {
                const data = response.data;
                setCollectors(data.map(el => 
                    ({value:el.id,label:el.name , data:el})));
            })
            .catch(() => setErrorMsg("Failed to load "));
        }, []);

	const handleClearWallet = () => {
		if(confirm('Are you sure you want to clear wallet balance?'))
		{
		put(CLEAR_COLLECTOR_WALLET, {collectorId, partnerId, partnerBranchId, note: bankNote})
		.then(response => {
			alert(response.message);
		})
		.catch(() => setErrorMsg("Failed to load "));
		}
	}

	const handleFileUpload = (event) => {
		const file = event.target.files[0];
		console.log(file.type);
		if(file.size > 1*1024*1024)
		{
			seterrorMsg('File size is larger than 1MB');
			setTimeout(()=>{
				seterrorMsg('');
			},1700)
		}
		if(file.type != 'image/jpeg' && file.type != 'image/png')
		{
			seterrorMsg('File type is incorrect');
			setTimeout(()=>{
				seterrorMsg('');
			},1700)
		}
		post(`${UPLOAD_FILE}`, { file, type:"collectors", fullPath:"true" }, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response) => {
				const data = response.data;
				setBankNote(data.path);
				// setLoading(false);
			})
			.catch((error) => {
			});
	}

    const handlePartnerId = (partnerId) =>
    {
        setPartnerId(partnerId);
        setPartnerBranches(partners.find(el => el.value == partnerId)?.data?.partnerBranch?.map(br => {
            return {value: br.id, label: br.name, data: br}
        }))
    }

		return (
			<React.Fragment>
				<div className="page-content">
					<div className="container-fluid">
						<Breadcrumbs title="Home" breadcrumbItem="Collectors" />
						<Row>
							<Col xl={12}>
								<Card>
									<CardBody>
										<Row>
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label">
                                            <Trans>Collector</Trans>
                                            </Label>
                                            <Select
                                            name="collectorId"
                                            value={
                                                collectors.find(el => el.value === collectorId)
                                            }
                                            options={collectors}
                                            className="form-control select2"
                                            onChange={e => setCollectorId(e.value)}
                                            />
                                        </div>
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label">
                                            <Trans>Partner</Trans>
                                            </Label>
                                            <Select
                                            name="partnerId"
                                            value={
                                                partners.find(el => el.value === partnerId)
                                            }
                                            options={partners}
                                            className="form-control select2"
                                            onChange={e => handlePartnerId(e.value)}
                                            />
                                        </div>
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label">
                                            <Trans>Partner Branch</Trans>
                                            </Label>
                                            <Select
                                            name="partnerBranchId"
                                            value={
                                                partnerBranches?.find(el => el.value === partnerBranchId)
                                            }
                                            options={partnerBranches}
                                            className="form-control select2"
                                            onChange={e => setPartnerBranchId(e.value)}
                                            />
                                        </div>
                                            <Label className="form-label">
                                                Wallet Balance <Trans size={5} style={{fontWeight:'bold'}}> 
                                                    {(collectors.find(el => el.value == collectorId?.toString())?.data.user.wallet?.find(w => w.partnerBranchId == partnerBranchId)?.balance?.toString())}</Trans>
                                            </Label>
										<div className="form-group col-md-4 mt-2">
											<div className="form-group col-md-12 mt-2">
												<Label className="form-label"><Trans>Upload bank note</Trans></Label>
												<input className="form-control" type="file" onChange={handleFileUpload} />
											</div>
											<div>

												<img src={bankNote} width="170" height="270" />
											</div>

										</div>
										<div className="form-group col-md-3 mt-2">
											<Label className="form-label">
											<Trans>Wallet Balance</Trans>
											</Label>
											<Input
											name="walletBalance"
											value={walletBalance}
											className="form-control"
											placeholder=""
											type="number"
											></Input>
										</div>
                                        <Row>
                                            <div className="form-group col-md-12 mt-2 text-center">
                                                <Button
                                                    type="button"
                                                    color="success"
                                                    onClick={handleClearWallet}
                                                >
                                                    Do Transfer
                                                </Button>
                                            </div>
                                        
                                        </Row>
										</Row>
									</CardBody>
								</Card>
					</Col>
				</Row>
			</div>
			</div>
			</React.Fragment>
	);
};

export default ClearWallet;
